(() => {
  const ACCORDION_ICON = `
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M21 12.5H3v-1h18v1Z"></path>
      <path d="M12.5 3v18h-1V3h1Z"></path>
    </svg>
  `;

  const isIgnorableText = (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '';

  const transformDescription = (root) => {
    if (!root || root.dataset.descriptionAccordionInitialized === 'true') {
      return;
    }

    const nodes = Array.from(root.childNodes).filter((node) => !isIgnorableText(node));
    const hasHeading = nodes.some(
      (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H3'
    );

    if (!hasHeading) {
      return;
    }

    root.dataset.descriptionAccordionInitialized = 'true';

    let introNodes = [];
    let introParagraphFound = false;
    let currentHeading = null;
    let currentBody = [];
    const groups = [];

    const pushGroup = () => {
      if (!currentHeading) {
        return;
      }
      groups.push({ heading: currentHeading, body: currentBody.slice() });
      currentHeading = null;
      currentBody = [];
    };

    nodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H3') {
        if (currentHeading) {
          pushGroup();
        }
        currentHeading = node;
        return;
      }

      if (!introParagraphFound) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'P') {
          introParagraphFound = true;
        }
        introNodes.push(node);
        return;
      }

      if (currentHeading) {
        currentBody.push(node);
      } else {
        introNodes.push(node);
      }
    });

    if (currentHeading) {
      pushGroup();
    }

    if (!groups.length) {
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'product-description-accordion';

    if (introNodes.length) {
      const intro = document.createElement('div');
      intro.className = 'product-description-accordion__intro product-accordion--content-body rte';
      introNodes.forEach((node) => intro.appendChild(node));
      wrapper.appendChild(intro);
    }

    const list = document.createElement('div');
    list.className = 'product-accordion';

    groups.forEach((group, index) => {
      const details = document.createElement('details');
      details.className = 'product-accordion--item border-bottom';
      if (index === 0) {
        details.open = true;
      }

      const summary = document.createElement('summary');
      summary.className = 'product-accordion--heading detail-summary';

      const heading = document.createElement('p');
      heading.className = 'product-accordion--heading-text h6';
      heading.innerHTML = group.heading.innerHTML;

      const icon = document.createElement('span');
      icon.className = 'product-accordion--icon';
      icon.innerHTML = ACCORDION_ICON;

      summary.appendChild(heading);
      summary.appendChild(icon);

      const content = document.createElement('div');
      content.className = 'product-accordion--content';
      content.setAttribute('data-accordion-content', '');

      const body = document.createElement('div');
      body.className = 'product-accordion--content-body rte';
      group.body.forEach((node) => body.appendChild(node));

      content.appendChild(body);
      details.appendChild(summary);
      details.appendChild(content);
      list.appendChild(details);
    });

    wrapper.appendChild(list);
    root.innerHTML = '';
    root.appendChild(wrapper);
  };

  const init = (scope = document) => {
    scope
      .querySelectorAll('[data-product-description-accordion]')
      .forEach((root) => transformDescription(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event && event.target) {
      init(event.target);
    }
  });
})();
